export interface TypeaheadModel {
  active: boolean;
  animating: boolean;
  processing: boolean;
  spinnerActive?: boolean;
}

export interface TypeaheadValue<T> {
  value: T;
  title: string;
  animate?: boolean;
  disabled?: boolean;
  selected?: boolean;
}

export interface TypeaheadOptions {
  pills?: boolean;
  modelPropertyName?: string;
  titlePropertyName?: string;
  responsePropertyName?: string;
  useREST?: boolean;
  returnModelProperty?: string;
  maxPills?: number;
  pillsOnEnter?: boolean;
}
